import { useIntl } from "react-intl";
import Markdown from "react-markdown";
import expertImg1 from "../../../../../assets/images/expert-img-1.png";

export const TextWithImage = () => {
  const { formatMessage } = useIntl();

  return (
    <section>
      <div className="container mx-auto">
        <div className="flex justify-center">
          <div className="hidden md:block w-1/4">
            <img src={expertImg1} alt="Text with image" />
          </div>
          <div className="w-full md:w-3/4 md:ps-8">
            <h3 className="text-6xl mb-10">Guia do Expert</h3>
            <Markdown
              components={{
                p: ({ children, ...rest }) => (
                  <p className="mb-4" {...rest}>
                    {children}
                  </p>
                ),
              }}
            >
              {formatMessage({ id: "GUIDE_FOR_EXPERT_IMAGE_AND_TEXT" })}
            </Markdown>
            <Markdown
              components={{
                p: ({ children, ...rest }) => (
                  <p className="mb-4" {...rest}>
                    {children}
                  </p>
                ),
              }}
            >
              {formatMessage({ id: "GUIDE_FOR_EXPERT_IMAGE_AND_TEXT_2" })}
            </Markdown>
            <Markdown
              components={{
                p: ({ children, ...rest }) => (
                  <p className="mb-4" {...rest}>
                    {children}
                  </p>
                ),
              }}
            >
              {formatMessage({ id: "GUIDE_FOR_EXPERT_IMAGE_AND_TEXT_3" })}
            </Markdown>
            <Markdown
              components={{
                p: ({ children, ...rest }) => (
                  <p className="mb-4" {...rest}>
                    {children}
                  </p>
                ),
              }}
            >
              {formatMessage({ id: "GUIDE_FOR_EXPERT_IMAGE_AND_TEXT_4" })}
            </Markdown>
            <Markdown
              components={{
                p: ({ children, ...rest }) => (
                  <p className="mb-4" {...rest}>
                    {children}
                  </p>
                ),
              }}
            >
              {formatMessage({ id: "GUIDE_FOR_EXPERT_IMAGE_AND_TEXT_5" })}
            </Markdown>
          </div>
        </div>
      </div>
    </section>
  );
};
